import React, { useContext, useState } from "react";
import { Box, Card, Divider, Typography } from "@mui/material";
import { Cancel } from "@mui/icons-material";
import { BookOnline, EmojiTransportation } from "@material-ui/icons";
import { BrandContext } from "../../../contexts/BrandContext";
import { getComponentsFromUtcDate, iconMap, outputCurrency } from "../../../contexts/BookingUtilities";
import CustomMenuList from "../CustomMenuList";
import axios from "../../../utils/axios";
import { cLog, cWarn } from "../CustomLogger";
import ChangeProviderDialog from "./ChangeProviderDialog";



export default function AdminData(props){
    
    const {
        fullData:{
            id:taxiBookingId,
            taxiBookingLogs,
            taxiBookingJobs
        },
        setIsLoaded,
        setShowLog,
        showLog
    } = props;

    let systemLogParsed = [];
    if(taxiBookingLogs){
        const {
            logText:systemLog
        }  = taxiBookingLogs;
        systemLogParsed = systemLog.split(/\n/g);
    }

    const brandContext = useContext(BrandContext);

    const {
        textContent:{
            showLogText='',
            hideLogText = '',
            logHeader = '',
            bookingJobsHeader = '',
            cancelBookingButton='',
            cycleTaxiBookingButton='',
            activateQuote='',
            externalStatusLabel='',
            internalStatusLabel='',
            externalIdLabel='',
            forceTaxiAssessmentButton='',
            changeProviderButton=''
        },
        textContent
    } = brandContext;

    
    const toggleLog = () => {
        setShowLog(!showLog);
    }

    const cycleTaxiBooking = () => {
        const apiPath = `${process.env.REACT_APP_API_URL}/cycletb/${taxiBookingId}`;
        axios.post(apiPath,{},{
            timeout: 300000,
            withCredentials:true
        }).then(res => {
            cLog(res);
            setIsLoaded(false);
        }).catch(err => {
            cWarn(err); 
        });
    }
    
    const assessTaxiBooking = () => {
        const apiPath = `${process.env.REACT_APP_API_URL}/assesstb/${taxiBookingId}`;
        axios.post(apiPath,{},{
            timeout: 300000,
            withCredentials:true
        }).then(res => {
            cLog(res);
            setIsLoaded(false);
        }).catch(err => {
            cWarn(err); 
        });
    }
    
    const cancelTaxiBookingJob = (id) => {
        const apiPath = `${process.env.REACT_APP_API_URL}/canceltbj/${id}`;
        axios.post(apiPath,{},{
            timeout: 300000,
            withCredentials:true
        }).then(res => {
            cLog(res);
            setIsLoaded(false);
        }).catch(err => {
            cWarn(err); 
        });
    }

    const activateTaxiBookingJob = (id) => {
        const apiPath = `${process.env.REACT_APP_API_URL}/activatetbj/${id}`;
        axios.post(apiPath,{},{
            timeout: 300000,
            withCredentials:true
        }).then(res => {
            cLog(res);
            setIsLoaded(false);
        }).catch(err => {
            cWarn(err); 
        });
    }

    const [showChangePrviderDialogue,setShowChangeProviderDialog] = useState(false);
    
    return (
        <Box>
            <Typography onClick={toggleLog} className="smallText" sx={{marginTop:1, cursor:'pointer'}} > {showLog ? hideLogText : showLogText}</Typography>
            {showLog &&
                <>
                    <Card variant="outlined" className="darkBox" sx={{marginTop:1, marginLeft:'-10px', marginRight:'-10px'}}>
                        <Typography className="smallText bodyBold">{logHeader}</Typography>
                        {systemLogParsed.map((log,index)=>(
                            <Typography className="smallText" key={index}>
                                {log}
                            </Typography>
                        ))}
                    </Card>
                    <Card variant="outlined" className="darkBox" sx={{marginTop:1, marginLeft:'-10px', marginRight:'-10px'}}>
                        <Box sx={{display:'flex'}}>
                            <Typography sx={{flexGrow:1}} className="smallText bodyBold">{bookingJobsHeader}</Typography>
                            <Box sx={{paddingLeft:1}}>
                                <CustomMenuList 
                                    id="admin"
                                    options={[
                                        {
                                            text: cycleTaxiBookingButton,
                                            iconComponent: iconMap.Travel,
                                            action: () => {
                                                cycleTaxiBooking();
                                            },
                                            branded: true
                                        },
                                        {
                                            text: forceTaxiAssessmentButton,
                                            iconComponent: iconMap.Travel,
                                            action: () => {
                                                assessTaxiBooking();
                                            },
                                            branded: true
                                        },
                                        {
                                            text: changeProviderButton,
                                            iconComponent: <EmojiTransportation/>,
                                            action: () => {
                                                setShowChangeProviderDialog(true);
                                            },
                                            branded: true
                                        },
                                    ]}
                                />
                            </Box>
                        </Box>
                        
                        {taxiBookingJobs.map((job,index)=>{
                            
                            const {
                                fp:{
                                    companyName=''
                                },
                                externalId='',
                                isActive,
                                status:{
                                    name:externalStatus
                                },
                                activationStatus:activationStatusDb,
                                taxiBookingJobLogs=[],
                                baseFare=0,
                                id:jobId
                            } = job

                            let activationStatus = '';
                            if(activationStatusDb){
                                const {textKey:activationStatusKey=''}=activationStatusDb;
                                activationStatus = textContent[activationStatusKey];
                            }

                            
                            let basefareFormat = 0;
                            if(baseFare){
                                basefareFormat = baseFare;
                            }
                            basefareFormat = outputCurrency(basefareFormat);

                            const activeState = {
                                borderLeft:'3px solid ##F4F6F8',
                                borderRight:'3px solid ##F4F6F8',
                                paddingLeft:'10px',
                                paddingRight:'10px',
                            };
                            if(isActive){
                                activeState.borderLeft = '3px solid #14ef10'
                                activeState.borderRight = '3px solid #14ef10'
                            }

                            return(
                                <Box key={index} sx={activeState} >
                                    <Box sx={{display:'flex', paddingTop:1}}>
                                        <Box sx={{flexGrow:1,paddingTop:1}}>
                                            <Box sx={{display:'flex'}}>
                                                <Typography className="smallText bodyBold" sx={{flexGrow:1}} >
                                                    {companyName} 
                                                </Typography>
                                                <Typography className="smallText bodyBold" >
                                                    (Ref. {taxiBookingId}-{jobId})
                                                </Typography>
                                            </Box>
                                            <Box sx={{display:'flex',paddingTop:1}}>
                                                <Box sx={{flexGrow:1}}>
                                                    <Typography className="smallText">
                                                        {externalStatusLabel} {externalStatus}
                                                    </Typography>
                                                    <Typography className="smallText">
                                                        {internalStatusLabel} {activationStatus}
                                                    </Typography>
                                                    <Typography className="smallText">
                                                        {externalIdLabel} {externalId}
                                                    </Typography>
                                                    <Box>
                                                        <Typography className="smallText bodyBold">{logHeader}</Typography>
                                                        {taxiBookingJobLogs.map((jobLog,j)=>{
                                                            const {
                                                                logTime=false,
                                                                status:{
                                                                    name:logStatusName=''
                                                                } 
                                                            } = jobLog;

                                                            let timeLabel = '';
                                                            if(logTime){
                                                                const {
                                                                    hours,
                                                                    mins
                                                                } = getComponentsFromUtcDate(logTime);
                                                                timeLabel = `${hours}:${mins}`;
                                                            }

                                                            return (
                                                                <Typography key={j} className="smallText">
                                                                    {timeLabel} - {logStatusName}
                                                                </Typography>
                                                            );
                                                        })}
                                                    </Box>
                                                </Box>
                                                <Box>
                                                    {basefareFormat}
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box sx={{paddingLeft:1}}>
                                            <CustomMenuList 
                                                id={index}
                                                options={[
                                                    {
                                                        text: cancelBookingButton,
                                                        iconComponent: <Cancel/>,
                                                        action: () => {
                                                            cancelTaxiBookingJob(jobId);
                                                            setIsLoaded(false);
                                                        },
                                                        branded: true
                                                    },
                                                    {
                                                        text: activateQuote,
                                                        iconComponent: <BookOnline/>,
                                                        action: () => {
                                                            activateTaxiBookingJob(jobId);
                                                            setIsLoaded(false);
                                                        },
                                                        branded: true
                                                    },
                                                ]}
                                            />
                                        </Box>
                                    </Box>
                                    <Divider/>
                                </Box>
                            );
                        })}
                    </Card>
                </>
            }
            {showChangePrviderDialogue &&
                <ChangeProviderDialog showDialogue={showChangePrviderDialogue} setShowDialogue={setShowChangeProviderDialog} taxiId={taxiBookingId} onComplete={()=>{setIsLoaded(false)}}/>
            }
        </Box>
    );

}


